export { MarketingSlider } from './MarketingSlider';
